import { useEffect, useState, useCallback } from "react";
import { usersService } from "features/users/services/users-service";
import type { User } from "features/users/types";

export const useFetchUser = (
  id: string,
  skipFetch?: boolean,
): { user: User | undefined; isLoading: boolean; error: any; refetch: () => void } => {
  const [user, setUser] = useState<User>();
  const [isLoading, setIsLoading] = useState(() => (typeof skipFetch === "boolean" ? skipFetch : true));
  const [refetchIndex, setRefetchIndex] = useState(0);
  const [error, setError] = useState(null);

  const refetch = useCallback(() => {
    setRefetchIndex(prevRefetchIndex => prevRefetchIndex + 1);
  }, []);

  useEffect((): any => {
    let abortController: AbortController | null;

    async function fetchData() {
      try {
        setIsLoading(true);
        setError(null);

        abortController = new AbortController();
        const response: User = await usersService.getUser(id, abortController);

        setUser(response);
      } catch (error_) {
        setError(error_);
        setUser(undefined);
        console.error(error_);
      } finally {
        setIsLoading(false);
      }
    }

    if (!skipFetch && id) {
      fetchData();
    }

    return () => abortController && abortController.abort();
  }, [id, refetchIndex]);

  return { user, isLoading, error, refetch };
};
